import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueAnimateOnScroll from 'vue-animate-onscroll';
Vue.use(VueAnimateOnScroll);
import 'animate.css';
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
